import {
  DEFAULT_PAGE_NUMBER,
  EMPTY_STRING,
  FILTER_NAMES as COMMON_FILTER_NAMES,
  ORDER,
  SORT_FIELDS as COMMON_SORT_FIELDS
} from '../base.js'
import {FILTERS_GROUPS_IDS} from '../common/filtersGroups.js'
import {VEHICLE_STATE_IDS} from './subscription.js'

/**
 * @exports AD_STATUS
 */
export const AD_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PREVIEW: 'preview'
}

export const RELATED_AD_CONTEXT = {
  PRIVATE_DETAIL: 'private-detail',
  PROFESSIONAL_DETAIL_TYPE_DISCOVER: 'professional-detail-type-discover',
  PROFESSIONAL_DETAIL_TYPE_START: 'professional-detail-type-start'
}

export const SUBSCRIPTION_AD_CONTEXT = {
  COMMITMENT: 'commitment',
  ALLOWANCE: 'allowance'
}

export const ADS_LIST_SIZE = 30

export const HAS_NEW_VEHICLE_ADS_LIST_ENABLED = true

export const HAS_SUBSCRIPTION_ADS_LIST_ENABLED = false

export const HAS_ADS_LIST_MODEL_DETAILS_CAROUSEL_ENABLED = false

export const SHOW_DEALER_RATING = true

export const DEFAULT_TAB = 1

export const DEFAULT_FILTER_VALUE = null
export const DEFAULT_BOOL_FILTER_VALUE = false
export const DEFAULT_OPTION_VALUE = 0

export const DEFAULT_KMS_MIN = 0
export const DEFAULT_KMS_MAX = 300000

export const DEFAULT_YEAR = 0
export const DEFAULT_YEAR_MIN = 1970
export const DEFAULT_YEAR_MAX = new Date().getFullYear()

export const DEFAULT_PRICE = 0
export const LAST_PRICE = 999999

export const PROVINCES_WITH_POSTAL_CODE = [28]

export const DEFAULT_LUGGAGE_CAPACITY_TYPE = DEFAULT_OPTION_VALUE

export const LAST_SEARCH_ITEMS_COUNT = 6

export const DEFAULT_TEXT = EMPTY_STRING

export const DEFAULT_KEYWORD = EMPTY_STRING

export const DEFAULT_MODEL = {
  id: DEFAULT_OPTION_VALUE,
  name: EMPTY_STRING
}

export const DEFAULT_TRANSMISSION_TYPE = DEFAULT_OPTION_VALUE

export const DEFAULT_COLOR = DEFAULT_OPTION_VALUE
export const DEFAULT_COLORS = []

export const DEFAULT_PROVINCE = DEFAULT_OPTION_VALUE
export const DEFAULT_PROVINCES = []

export const DEFAULT_EQUIPMENT = DEFAULT_OPTION_VALUE
export const DEFAULT_EQUIPMENTS = []

export const DEFAULT_FUEL_TYPE = DEFAULT_OPTION_VALUE
export const DEFAULT_FUEL_TYPES = []

export const DRIVEN_WHEELS_ALL_ID = 1
export const DRIVEN_WHEELS_FRONT_ID = 3
export const DRIVEN_WHEELS_REAR_ID = 4

export const ENVIRONMENTAL_LABELS_0_ID = '0'
export const ENVIRONMENTAL_LABELS_ECO_ID = 'ECO'
export const ENVIRONMENTAL_LABELS_B_ID = 'B'
export const ENVIRONMENTAL_LABELS_C_ID = 'C'

export const FUEL_TYPE_DIESEL_ID = 1
export const FUEL_TYPE_GASOLINE_ID = 2
export const FUEL_TYPE_ELECTRIC_ID = 3
export const FUEL_TYPE_HYBRID_ID = 4
export const FUEL_TYPE_HYBRID_PLUG_IN_ID = 5
export const FUEL_TYPE_GLP_ID = 6
export const FUEL_TYPE_CNG_ID = 7
export const FUEL_TYPE_OTHER_ID = 8

export const DEFAULT_CUBIC_CAPACITY = {FROM: DEFAULT_OPTION_VALUE, TO: DEFAULT_OPTION_VALUE}
export const DEFAULT_CUBIC_CAPACITIES = []

export const DEFAULT_BODY_TYPE = DEFAULT_OPTION_VALUE
export const DEFAULT_BODY_TYPES = []

export const DEFAULT_ONLINE_SERVICES = DEFAULT_BOOL_FILTER_VALUE

export const DEFAULT_SEARCH_TEXT = EMPTY_STRING

export const DEFAULT_SELLER_TYPE = DEFAULT_OPTION_VALUE

export const DEFAULT_VEHICLE_STATE = EMPTY_STRING

export const DEFAULT_DOORS = []

export const DEFAULT_HP = DEFAULT_OPTION_VALUE
export const DEFAULT_HP_MIN = 0
export const DEFAULT_HP_MAX = 999

export const DEFAULT_LITRES = DEFAULT_OPTION_VALUE

export const DEFAULT_DRIVEN_WHEELS = []

export const DEFAULT_ENVIRONMENTAL_LABEL = DEFAULT_OPTION_VALUE
export const DEFAULT_ENVIRONMENTAL_LABELS = []

export const DEFAULT_VERSION = EMPTY_STRING

export const DEFAULT_VEHICLE = {
  [COMMON_FILTER_NAMES.MAKE]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.MODEL]: DEFAULT_MODEL,
  [COMMON_FILTER_NAMES.VERSION]: DEFAULT_VERSION
}
export const DEFAULT_EXCLUDED_VEHICLES = []
export const DEFAULT_VEHICLES = []

export const DEFAULT_LOCATION_MAX_RADIO = 300
export const DEFAULT_LOCATION_MIN_RADIO = 10
export const DEFAULT_LOCATION_TEXT = EMPTY_STRING
export const DEFAULT_LOCATION = {
  lat: DEFAULT_FILTER_VALUE,
  long: DEFAULT_FILTER_VALUE,
  radio: DEFAULT_FILTER_VALUE,
  text: DEFAULT_FILTER_VALUE,
  provinceId: DEFAULT_FILTER_VALUE
}

/**
 * @exports URL_PATTERN
 */
export const URL_PATTERN =
  '?MakeId={MAKE_ID}&ModelId={MODEL_ID}&PrvId={PRV_ID}&FuelTypeId={FUEL_TYPE_ID}&MaxKms={MAX_KMS}&MinKms={MIN_KMS}&MaxYear={MAX_YEAR}&MinYear={MIN_YEAR}&MaxPrice={MAX_PRICE}&text={TEXT}'

export const URL_VEHICLE_CARD_FALLBACK = '/detail'

/**
 * @exports prices
 */
export const prices = [
  1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000,
  19000, 20000, 21000, 22000, 23000, 24000, 25000, 30000, 35000, 40000, 50000, 60000, 70000
]

/**
 * @exports priceChipSeeds
 */
export const priceChipSeeds = [1000, 2000, 3000, 5000]

/**
 * @exports priceToChipSeeds
 */
export const priceToChipSeeds = [5000, 10000, 15000, 20000]

/**
 * @exports kmsChipSeeds
 */
export const kmsChipSeeds = [2500, 100000, 120000, 140000]

/**
 * @exports kmsToChipSeeds
 */
export const kmsToChipSeeds = [100000, 120000, 140000, 160000]

/**
 * @exports instalmentAmounts
 */
export const instalmentAmounts = [50, 100, 150, 200, 250, 300, 350, 400, 500, 600, 800, 1000]

/**
 * @exports financingEntry
 */
export const financingEntry = [0, 500, 1000, 1500, 2000, 3000, 4000, 5000, 6000]

/**
 * @exports financingTerms
 */
export const financingTerms = [24, 36, 48, 60, 72, 84, 96, 108, 120]

/**
 * @exports subscriptionMonthlyFees
 */
export const subscriptionMonthlyFees = [
  150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1050, 1100, 1150, 1200,
  1250, 1300, 1350, 1400, 1450, 1500
]

/**
 * @exports kms
 */
export const kms = [
  2500, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 60000, 70000, 80000, 90000, 100000, 120000,
  140000, 160000, 180000, 200000
]

/**
 * @exports litres
 */
export const litres = [
  1000, 1200, 1400, 1600, 1800, 1900, 2000, 2200, 2400, 2600, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000
]

export const LUGGAGE_CAPACITY_SMALL = {
  id: 1,
  label: 'SEARCH_BOX_SELECT_LUGGAGE_CAPACITY_TYPE_SMALL',
  value: {from: null, to: 199}
}

export const LUGGAGE_CAPACITY_MEDIUM = {
  id: 2,
  label: 'SEARCH_BOX_SELECT_LUGGAGE_CAPACITY_TYPE_MEDIUM',
  value: {from: 200, to: 399}
}

export const LUGGAGE_CAPACITY_LARGE = {
  id: 3,
  label: 'SEARCH_BOX_SELECT_LUGGAGE_CAPACITY_TYPE_LARGE',
  value: {from: 400, to: null}
}

/**
 * @exports luggageCapacityTypes
 */
export const luggageCapacityTypes = [
  {
    id: DEFAULT_LUGGAGE_CAPACITY_TYPE,
    label: 'SEARCH_BOX_SELECT_LUGGAGE_CAPACITY_TYPE_ALL'
  },
  LUGGAGE_CAPACITY_SMALL,
  LUGGAGE_CAPACITY_MEDIUM,
  LUGGAGE_CAPACITY_LARGE
]

/**
 * @exports fuelTypes
 */
export const fuelTypes = [
  {
    id: DEFAULT_FUEL_TYPE,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE',
    slug: undefined
  },
  {
    id: FUEL_TYPE_DIESEL_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_DIESEL',
    slug: 'diesel'
  },
  {
    id: FUEL_TYPE_ELECTRIC_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_ELECTRIC_HYBRID',
    slug: 'electrico'
  },
  {
    id: FUEL_TYPE_GASOLINE_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_GASOLINE',
    slug: 'gasolina'
  },
  {
    id: FUEL_TYPE_OTHER_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_OTHER',
    slug: 'otro'
  }
]

/**
 * @exports specificFueltypes
 */
export const specificFueltypes = [
  {
    id: FUEL_TYPE_DIESEL_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_DIESEL',
    slug: 'diesel'
  },
  {
    id: FUEL_TYPE_GASOLINE_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_GASOLINE',
    slug: 'gasolina'
  },
  {
    id: FUEL_TYPE_ELECTRIC_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_ELECTRIC',
    slug: 'electrico'
  },
  {
    id: FUEL_TYPE_HYBRID_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_HYBRID',
    slug: 'hibrido'
  },
  {
    id: FUEL_TYPE_HYBRID_PLUG_IN_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_HYBRID_PLUG_IN',
    slug: 'hibrido_enchufable'
  },
  {
    id: FUEL_TYPE_GLP_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_GLP',
    slug: 'gas_glp'
  },
  {
    id: FUEL_TYPE_CNG_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_CNG',
    slug: 'gas_natural'
  },
  {
    id: FUEL_TYPE_OTHER_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_OTHER',
    slug: 'otro'
  }
]

export const COLORS_ID = {
  YELLOW: '1',
  BLUE: '2',
  BEIGE: '3',
  WHITE: '4',
  GARNET: '5',
  GRAY: '6',
  BROWN: '7',
  ORANGE: '8',
  BLACK: '9',
  RED: '10',
  PINK: '11',
  GREEN: '12',
  PURPLE: '13'
}

export const colors = [
  {id: COLORS_ID.YELLOW, label: 'COMMON.COLOR_YELLOW'},
  {id: COLORS_ID.BLUE, label: 'COMMON.COLOR_BLUE'},
  {id: COLORS_ID.BEIGE, label: 'COMMON.COLOR_BEIGE'},
  {id: COLORS_ID.WHITE, label: 'COMMON.COLOR_WHITE'},
  {id: COLORS_ID.GARNET, label: 'COMMON.COLOR_GARNET'},
  {id: COLORS_ID.GRAY, label: 'COMMON.COLOR_GRAY'},
  {id: COLORS_ID.BROWN, label: 'COMMON.COLOR_BROWN'},
  {id: COLORS_ID.ORANGE, label: 'COMMON.COLOR_ORANGE'},
  {id: COLORS_ID.BLACK, label: 'COMMON.COLOR_BLACK'},
  {id: COLORS_ID.RED, label: 'COMMON.COLOR_RED'},
  {id: COLORS_ID.PINK, label: 'COMMON.COLOR_PINK'},
  {id: COLORS_ID.GREEN, label: 'COMMON.COLOR_GREEN'},
  {id: COLORS_ID.PURPLE, label: 'COMMON.COLOR_PURPLE'}
]

export const environmentalLabels = [
  {
    id: ENVIRONMENTAL_LABELS_0_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.0'
  },
  {
    id: ENVIRONMENTAL_LABELS_ECO_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.ECO'
  },
  {
    id: ENVIRONMENTAL_LABELS_C_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.C'
  },
  {
    id: ENVIRONMENTAL_LABELS_B_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.B'
  }
]

export const ENVIRONMENTAL_LABEL_ICONS = {
  0: 'images/common/eco-label-icons/0.svg',
  ECO: 'images/common/eco-label-icons/eco.svg',
  B: 'images/common/eco-label-icons/b.svg',
  C: 'images/common/eco-label-icons/c.svg'
}

export const drivenWheels = [
  {
    id: DRIVEN_WHEELS_ALL_ID,
    label: 'SEARCH_BOX_SELECT_DRIVEN_WHEELS_ALL'
  },
  {
    id: DRIVEN_WHEELS_FRONT_ID,
    label: 'SEARCH_BOX_SELECT_DRIVEN_WHEELS_FRONT'
  },
  {
    id: DRIVEN_WHEELS_REAR_ID,
    label: 'SEARCH_BOX_SELECT_DRIVEN_WHEELS_REAR'
  }
]

export const TRANNSMISSION_TYPE_ID_AUTOMATIC = 1
export const TRANNSMISSION_TYPE_ID_MANUAL = 2

export const transmissionTypes = [
  {
    id: TRANNSMISSION_TYPE_ID_AUTOMATIC,
    label: 'COMMON.TRANSMISSION_AUTOMATIC'
  },
  {id: TRANNSMISSION_TYPE_ID_MANUAL, label: 'COMMON.TRANSMISSION_MANUAL'}
]

/**
 * @exports taxTypes
 */
export const taxTypes = [
  {
    id: 1,
    label: 'IVA'
  },
  {
    id: 2,
    label: 'IGIC'
  }
]

export const BODY_TYPE_SEDAN_ID = 1
export const BODY_TYPE_COUPE_ID = 2
export const BODY_TYPE_CABRIO_ID = 3
export const BODY_TYPE_FAMILIAR_ID = 4
export const BODY_TYPE_MINIVAN_ID = 5
export const BODY_TYPE_4X4_ID = 6
export const BODY_TYPE_PICK_UP_ID = 7
export const BODY_TYPE_VANS_ID = 8

export const bodyTypesImages = {
  [BODY_TYPE_SEDAN_ID]: 'https://s.ccdn.es/images/form/body-berlina.png',
  [BODY_TYPE_FAMILIAR_ID]: 'https://s.ccdn.es/images/form/body-familiar.png',
  [BODY_TYPE_COUPE_ID]: 'https://s.ccdn.es/images/form/body-coupe.png',
  [BODY_TYPE_MINIVAN_ID]: 'https://s.ccdn.es/images/form/body-monovolumen.png',
  [BODY_TYPE_4X4_ID]: 'https://s.ccdn.es/images/form/body-4x4-suv.png',
  [BODY_TYPE_CABRIO_ID]: 'https://s.ccdn.es/images/form/body-cabrio.png',
  [BODY_TYPE_PICK_UP_ID]: 'https://s.ccdn.es/images/form/body-pick-up.png',
  [BODY_TYPE_VANS_ID]: 'https://s.ccdn.es/images/form/body-furgoneta.png'
}

/**
 * @exports bodyTypes
 */
export const bodyTypes = [
  {
    id: BODY_TYPE_SEDAN_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_SEDAN_ID],
    label: 'BODY_TYPE_SEDAN',
    slug: 'berlina',
    url: '/berlina/segunda-mano/'
  },
  {
    id: BODY_TYPE_FAMILIAR_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_FAMILIAR_ID],
    label: 'BODY_TYPE_FAMILIAR',
    slug: 'familiar',
    url: '/familiar/segunda-mano/'
  },
  {
    id: BODY_TYPE_COUPE_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_COUPE_ID],
    label: 'BODY_TYPE_COUPE',
    slug: 'coupe',
    url: '/coupe/segunda-mano/'
  },
  {
    id: BODY_TYPE_MINIVAN_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_MINIVAN_ID],
    label: 'BODY_TYPE_MINIVAN',
    slug: 'monovolumen',
    url: '/monovolumen/segunda-mano/'
  },
  {
    id: BODY_TYPE_4X4_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_4X4_ID],
    label: 'BODY_TYPE_4X4',
    slug: '4x4',
    url: '/4x4/segunda-mano/'
  },
  {
    id: BODY_TYPE_CABRIO_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_CABRIO_ID],
    label: 'BODY_TYPE_CABRIO',
    slug: 'cabrio',
    url: '/cabrio/segunda-mano/'
  },
  {
    id: BODY_TYPE_PICK_UP_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_PICK_UP_ID],
    label: 'BODY_TYPE_PICK_UP',
    slug: 'pick_up',
    url: '/pick_up/segunda-mano/'
  },
  {
    id: BODY_TYPE_VANS_ID,
    imageSrc: bodyTypesImages[BODY_TYPE_VANS_ID],
    label: 'BODY_TYPE_VANS',
    slug: 'furgonetas',
    url: '/furgonetas/segunda-mano/'
  }
]

export const BODY_TYPE_CATEGORY = {}

export const seats = [
  {
    id: '2',
    label: '2'
  },
  {
    id: '3',
    label: '3'
  },
  {
    id: '4',
    label: '4'
  },
  {
    id: '5',
    label: '5'
  },
  {
    id: '6',
    label: '6'
  },
  {
    id: '7',
    label: '7'
  },
  {
    id: '8',
    label: '8'
  },
  {
    id: '9',
    label: '9'
  }
]

export const doors = [
  {id: '2', label: '2'},
  {id: '3', label: '3'},
  {id: '4', label: '4'},
  {id: '5', label: '5'},
  {id: '6', label: '6'},
  {id: '7', label: '7'}
]

export const hp = [50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 250, 300, 350, 400, 500]
export const kwFromHp = {
  50: 37,
  60: 44,
  70: 51,
  80: 59,
  90: 66,
  100: 74,
  110: 81,
  120: 88,
  130: 96,
  140: 103,
  150: 110,
  160: 118,
  170: 125,
  180: 132,
  190: 140,
  200: 147,
  250: 184,
  300: 221,
  350: 258,
  400: 294,
  500: 368
}

export const equipments = [
  {id: '1', label: 'Techo solar'},
  {id: '2', label: 'Cuero'},
  {id: '3', label: 'Navegador'},
  {id: '4', label: 'ISOFIX'},
  {id: '5', label: 'Bola de remolque'},
  {id: '6', label: 'Faros de xenon'},
  {id: '7', label: 'Faros de LED'},
  {id: '8', label: 'Cámara de aparcamiento'},
  {id: '9', label: 'Bluetooth'},
  {id: '10', label: 'Aire Acondicionado'},
  {id: '11', label: 'Asientos calefactables'},
  {
    id: '12',
    label: 'Sensor de aparcamiento trasero'
  }
]

/**
 * @exports SUGGEST_DEBOUNCE_TIME (300ms)
 */
export const SUGGEST_DEBOUNCE_TIME = 300

/**
 * @exports DEFAULT_RELATED_ADS_COUNT
 */
export const DEFAULT_RELATED_ADS_COUNT = 4

/**
 * @exports DEFAULT_PAYMENT_AD_PRICE
 */
export const DEFAULT_PAYMENT_AD_PRICE = 39.95

/**
 * @exports NUMBER_FREE_ADS
 */
export const NUMBER_FREE_ADS = 2

/**
 * @exports SHOW_CUSTOM_MONTHLY_FEE
 */
export const SHOW_CUSTOM_MONTHLY_FEE = false

/**
 * @exports SHOW_WARRANTY
 */
export const SHOW_WARRANTY = true

/**
 * @exports SHOW_TAXES
 */
export const SHOW_TAXES = true

/**
 * @exports SHOW_WARRANTY_FREE_TEXT
 */
export const SHOW_WARRANTY_FREE_TEXT = false

/**
 * @exports SEGUNDA_MANO_CATEGORY1_ID
 * @description This apply not only for Segunda Mano, but also Vehiculo Nuevo and KM0. Would make sense to rename this to CAR_CATEGORY1_ID
 */
export const SEGUNDA_MANO_CATEGORY1_ID = 2500
export const VANS_AND_COMMERCIAL_CATEGORY1_ID = 2900
export const AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID = 3820
export const CARS_WITHOUT_LICENSE_CATEGORY1_ID = 4000
export const CLASSIC_AND_COMPETITION_CATEGORY1_ID = 3110
export const ACCESSORIES_CATEGORY1_ID = 2790

export const FILTER_NAMES = COMMON_FILTER_NAMES

export const DEFAULT_CATEGORY1_ID = SEGUNDA_MANO_CATEGORY1_ID

/**
 *
 * @exports DEFAULT_CATEGORIES
 */
export const DEFAULT_CATEGORIES = {CATEGORY_1IDS: [DEFAULT_CATEGORY1_ID], CATEGORY_2IDS: []}

export const OFFER_TYPE_SECOND_HAND = 0
export const OFFER_TYPE_NEW = 1
export const OFFER_TYPE_KM0 = 2
export const OFFER_TYPE_SUBSTITUTION = 3
export const OFFER_TYPE_MANAGEMENT = 4
export const OFFER_TYPE_DEMONSTRATION = 5
export const OFFER_TYPE_RENTAL = 7
export const OFFER_TYPE_PRE_OWNED = 8
export const OFFER_TYPE_SUBSCRIPTION = 10
export const DEFAULT_OFFER_TYPE_ID = OFFER_TYPE_SECOND_HAND
export const UNSELECTED_OFFER_TYPE = -1
export const ALL_OFFER_TYPES = [
  OFFER_TYPE_SECOND_HAND,
  OFFER_TYPE_NEW,
  OFFER_TYPE_KM0,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]
export const ALL_OFFER_TYPES_IN_SECOND_HAND = [
  OFFER_TYPE_SECOND_HAND,
  OFFER_TYPE_KM0,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]
export const ALL_OFFER_TYPES_IN_KM0 = [
  OFFER_TYPE_NEW,
  OFFER_TYPE_KM0,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]

const SECOND_HAND_FILTERS_CONF = [
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.INSTALMENT,
  FILTER_NAMES.HAS_INSTALMENT,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_PRICE_DROP,
  FILTER_NAMES.PRICE_RANK,
  FILTER_NAMES.HAS_RESERVATION,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.SELLER_TYPE,
  FILTER_NAMES.RATING,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.COLOR,
  FILTER_NAMES.TRANSMISSION_TYPE,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.ELECTRIC_AUTONOMY,
  FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY,
  FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID,
  FILTER_NAMES.ENVIRONMENTAL_LABEL,
  FILTER_NAMES.DRIVEN_WHEELS,
  FILTER_NAMES.HP,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.SEAT,
  FILTER_NAMES.LUGGAGE_CAPACITY,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.SEARCH_TEXT,
  FILTER_NAMES.HAS_WARRANTY,
  FILTER_NAMES.IS_CERTIFIED,
  FILTER_NAMES.HAS_PHOTO
]

const SECOND_HAND_SEARCH_TOPBAR_FILTERS = [
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.PRICE,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.FUEL_TYPE
]

const KM0_FILTERS_CONF = [
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.INSTALMENT,
  FILTER_NAMES.HAS_INSTALMENT,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_PRICE_DROP,
  FILTER_NAMES.PRICE_RANK,
  FILTER_NAMES.HAS_RESERVATION,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.RATING,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.COLOR,
  FILTER_NAMES.TRANSMISSION_TYPE,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.ELECTRIC_AUTONOMY,
  FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY,
  FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID,
  FILTER_NAMES.ENVIRONMENTAL_LABEL,
  FILTER_NAMES.DRIVEN_WHEELS,
  FILTER_NAMES.HP,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.SEAT,
  FILTER_NAMES.LUGGAGE_CAPACITY,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.SEARCH_TEXT,
  FILTER_NAMES.IS_CERTIFIED,
  FILTER_NAMES.HAS_STOCK,
  FILTER_NAMES.HAS_PHOTO
]

const KM0_SEARCH_TOPBAR_FILTERS = [
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.PRICE,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.FUEL_TYPE
]

const NEW_VEHICLE_FILTERS_CONF = [
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.INSTALMENT,
  FILTER_NAMES.HAS_INSTALMENT,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_PRICE_DROP,
  FILTER_NAMES.PRICE_RANK,
  FILTER_NAMES.HAS_RESERVATION,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.RATING,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.COLOR,
  FILTER_NAMES.TRANSMISSION_TYPE,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.ELECTRIC_AUTONOMY,
  FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY,
  FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID,
  FILTER_NAMES.ENVIRONMENTAL_LABEL,
  FILTER_NAMES.DRIVEN_WHEELS,
  FILTER_NAMES.HP,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.SEAT,
  FILTER_NAMES.LUGGAGE_CAPACITY,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.SEARCH_TEXT,
  FILTER_NAMES.IS_CERTIFIED,
  FILTER_NAMES.HAS_STOCK,
  FILTER_NAMES.HAS_PHOTO
]

const NEW_VEHICLE_SEARCH_TOPBAR_FILTERS = [
  FILTER_NAMES.VEHICLES,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.FUEL_TYPE
]

const VANS_AND_COMMERCIAL_SEARCH_TOPBAR_FILTERS = [
  FILTER_NAMES.PRICE,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.KMS,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.FUEL_TYPE
]

const AUTOCARAVANS_AND_TRAILERS_SEARCH_TOPBAR_FILTERS = [
  FILTER_NAMES.PRICE,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.SELLER_TYPE,
  FILTER_NAMES.CATEGORY_2
]

const CARS_WITHOUT_LICENSE_SEARCH_TOPBAR_FILTERS = [
  FILTER_NAMES.PRICE,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.SELLER_TYPE
]

const CLASSIC_AND_COMPETITION_SEARCH_TOPBAR_FILTERS = [
  FILTER_NAMES.PRICE,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.SELLER_TYPE
]

export const SUBSCRIPTION_FILTERS_CONF = [
  FILTER_NAMES.VEHICLE_STATE,
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE,
  FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.TRANSMISSION_TYPE
]

export const MODELS_LIST_FILTERS_CONF = [
  FILTER_NAMES.MAKE,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.BODY_TYPE
]

export const ALL_OFFER_TYPES_ADS_FILTERS_MAP = [
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.FINANCED_PRICE,
  FILTER_NAMES.INSTALMENT,
  FILTER_NAMES.HAS_INSTALMENT,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_PRICE_DROP,
  FILTER_NAMES.PRICE_RANK,
  FILTER_NAMES.HAS_RESERVATION,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.SELLER_TYPE,
  FILTER_NAMES.RATING,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.COLOR,
  FILTER_NAMES.TRANSMISSION_TYPE,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.ELECTRIC_AUTONOMY,
  FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY,
  FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID,
  FILTER_NAMES.ENVIRONMENTAL_LABEL,
  FILTER_NAMES.DRIVEN_WHEELS,
  FILTER_NAMES.HP,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.SEAT,
  FILTER_NAMES.LUGGAGE_CAPACITY,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.SEARCH_TEXT,
  FILTER_NAMES.HAS_WARRANTY,
  FILTER_NAMES.IS_CERTIFIED,
  FILTER_NAMES.HAS_STOCK,
  FILTER_NAMES.HAS_PHOTO
]

export const DEFAULT_FILTERS_MAP = ALL_OFFER_TYPES_ADS_FILTERS_MAP
export const DEFAULT_SEARCH_TOPBAR_FILTERS_MAP = KM0_SEARCH_TOPBAR_FILTERS

/**
 * @exports ADS_FILTERS_MAP
 */
export const ADS_FILTERS_MAP = {
  [SEGUNDA_MANO_CATEGORY1_ID]: [
    SECOND_HAND_FILTERS_CONF,
    NEW_VEHICLE_FILTERS_CONF,
    KM0_FILTERS_CONF,
    KM0_FILTERS_CONF,
    KM0_FILTERS_CONF,
    KM0_FILTERS_CONF
  ],
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: [
    [
      FILTER_NAMES.VERSION,
      FILTER_NAMES.INSTALMENT,
      FILTER_NAMES.HAS_INSTALMENT,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PRICE_DROP,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.RATING,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.KMS,
      FILTER_NAMES.SEAT,
      FILTER_NAMES.HP,
      FILTER_NAMES.FUEL_TYPE,
      FILTER_NAMES.CATEGORY_2,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.VERSION,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PRICE_DROP,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.RATING,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.KMS,
      FILTER_NAMES.CATEGORY_2,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.VERSION,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PRICE_DROP,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.RATING,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: [
    [
      FILTER_NAMES.VERSION,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PRICE_DROP,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.RATING,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.CATEGORY_2,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.HAS_PHOTO
    ]
  ]
}

export const DEFAULT_MODEL_ID = 0

export const FIELDS_WITH_SEARCH_BAR = [
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL,
  FILTER_NAMES.PROVINCE,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.COLOR
]

/**
 * @exports ADS_SEARCH_TOPBAR_FILTERS_MAP
 */
export const ADS_SEARCH_TOPBAR_FILTERS_MAP = {
  [SEGUNDA_MANO_CATEGORY1_ID]: [
    SECOND_HAND_SEARCH_TOPBAR_FILTERS,
    NEW_VEHICLE_SEARCH_TOPBAR_FILTERS,
    KM0_SEARCH_TOPBAR_FILTERS,
    KM0_SEARCH_TOPBAR_FILTERS,
    KM0_SEARCH_TOPBAR_FILTERS,
    KM0_SEARCH_TOPBAR_FILTERS
  ],
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: [VANS_AND_COMMERCIAL_SEARCH_TOPBAR_FILTERS],
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: [AUTOCARAVANS_AND_TRAILERS_SEARCH_TOPBAR_FILTERS],
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: [CARS_WITHOUT_LICENSE_SEARCH_TOPBAR_FILTERS],
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: [CLASSIC_AND_COMPETITION_SEARCH_TOPBAR_FILTERS]
}

/**
 * @exports TECHNICAL_DETAILS_SEARCH_FILTERS_MAP
 */
export const TECHNICAL_DETAILS_SEARCH_FILTERS_MAP = [
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL,
  FILTER_NAMES.VERSION,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.HP
]

/**
 * @exports ADS_SEARCH_LITE_FILTERS_MAP
 */
export const ADS_SEARCH_LITE_FILTERS_MAP = [
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.VEHICLES,
  FILTER_NAMES.PROVINCE,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.INSTALMENT
]

export const CATEGORY2_ID_CAR = 2500
export const CATEGORY2_ID_SERVICES_GARAGE = 2700
export const CATEGORY2_ID_TUNING = 2770
export const CATEGORY2_ID_RENTAL = 2780
export const CATEGORY2_ID_ALL_TERRAIN_VEHICLE = 2810
export const CATEGORY2_ID_BUS = 2910
export const CATEGORY2_ID_TRUCK = 2920
export const CATEGORY2_ID_VAN = 2930
export const CATEGORY2_ID_LICENSES_AND_TRANSPORT_CARDS = 2990
export const CATEGORY2_ID_CLASSIC = 3110
export const CATEGORY2_ID_COMPETITION = 3111
export const CATEGORY2_ID_CARAVAN = 3820
export const CATEGORY2_ID_AUTOCARAVAN = 3821
export const CATEGORY2_ID_TRAILER_2 = 3822
export const CATEGORY2_ID_WITHOUT_DRIVING_LICENSE = 4000

export const VANS_AND_COMMERCIAL_CATEGORY2_ID = [
  {
    label: 'CATEGORY_2_VAN',
    id: CATEGORY2_ID_VAN
  },
  {
    label: 'CATEGORY_2_TRUCK',
    id: CATEGORY2_ID_TRUCK
  },
  {
    label: 'CATEGORY_2_BUS',
    id: CATEGORY2_ID_BUS
  }
]

export const VANS_AND_COMMERCIAL_CATEGORY3_ID = [
  {
    label: 'CATEGORY_2_TRUCK',
    id: CATEGORY2_ID_TRUCK
  },
  {
    label: 'CATEGORY_2_BUS',
    id: CATEGORY2_ID_BUS
  }
]

export const AUTOCARAVANS_AND_TRAILERS_CATEGORY2_ID = [
  {
    label: 'CATEGORY_2_AUTOCARAVAN',
    id: CATEGORY2_ID_AUTOCARAVAN
  },
  {
    label: 'CATEGORY_2_CARAVAN',
    id: CATEGORY2_ID_CARAVAN
  },
  {
    label: 'CATEGORY_2_TRAILER',
    id: CATEGORY2_ID_TRAILER_2
  }
]

export const CLASSIC_AND_COMPETITION_CATEGORY2_ID = [
  {
    label: 'CATEGORY_2_CLASSIC',
    id: CATEGORY2_ID_CLASSIC
  },
  {
    label: 'CATEGORY_2_COMPETITION',
    id: CATEGORY2_ID_COMPETITION
  }
]

export const SEGUNDA_MANO_CATEGORY2_ID = [
  {
    label: 'COMMON.CATEGORIES.COCHE_AND_4x4',
    optionalText: 'PUBLISH_AD.NAVIGATION_OPTIONAL_TEXT',
    id: 0
  },
  {
    label: 'COMMON.CATEGORIES.VAN',
    id: CATEGORY2_ID_VAN
  },
  {
    label: 'COMMON.CATEGORIES.COMMERCIAL',
    id: VANS_AND_COMMERCIAL_CATEGORY1_ID,
    children: VANS_AND_COMMERCIAL_CATEGORY3_ID
  },
  {
    label: 'NAVIGATION_MAIN_MORE_VEHICLES_CARS_WITHOUT_LICENSE_TEXT',
    id: CARS_WITHOUT_LICENSE_CATEGORY1_ID
  },
  {
    label: 'COMMON.CATEGORIES.AUTOCARAVANS_OR_TRAILERS',
    id: AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID
  },
  {
    label: 'COMMON.CATEGORIES.CLASSIC_OR_COMPETITION',
    id: CLASSIC_AND_COMPETITION_CATEGORY1_ID
  },
  {
    label: 'COMMON_ACCESSORY',
    id: ACCESSORIES_CATEGORY1_ID
  }
]

export const CATEGORY2_MAP = {
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: VANS_AND_COMMERCIAL_CATEGORY2_ID,
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: AUTOCARAVANS_AND_TRAILERS_CATEGORY2_ID,
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: CLASSIC_AND_COMPETITION_CATEGORY2_ID,
  [SEGUNDA_MANO_CATEGORY1_ID]: SEGUNDA_MANO_CATEGORY2_ID
}

export const offerTypes = [
  {
    id: OFFER_TYPE_SECOND_HAND,
    label: 'COMMON.OFFER_TYPE.SECOND_HAND'
  },
  {
    id: OFFER_TYPE_NEW,
    label: 'COMMON.OFFER_TYPE.NEW'
  },
  {
    id: OFFER_TYPE_KM0,
    label: 'COMMON.OFFER_TYPE.KM0'
  },
  {
    id: OFFER_TYPE_SUBSTITUTION,
    label: 'COMMON.OFFER_TYPE.SUBSTITUTION'
  },
  {
    id: OFFER_TYPE_MANAGEMENT,
    label: 'COMMON.OFFER_TYPE.MANAGEMENT'
  },
  {
    id: OFFER_TYPE_DEMONSTRATION,
    label: 'COMMON.OFFER_TYPE.DEMONSTRATION'
  }
]

export const adsListSearchOfferTypes = [
  {
    id: OFFER_TYPE_SECOND_HAND,
    label: 'COMMON_OPPORTUNITY'
  },
  {
    id: OFFER_TYPE_KM0,
    label: 'COMMON.OFFER_TYPE.KM0'
  },
  {
    id: OFFER_TYPE_NEW,
    label: 'COMMON.OFFER_TYPE.NEW'
  }
]

export const vehicleStates = [
  {
    id: VEHICLE_STATE_IDS.NEW,
    label: 'COMMON.OFFER_TYPE.NEW'
  },
  {
    id: VEHICLE_STATE_IDS.USED,
    label: 'COMMON_OPPORTUNITY'
  }
]

export const DEFAULT_OFFER_TYPE = -1

/**
 * @exports TAGS_VISIBILITY
 */
export const TAGS_VISIBILITY = {
  FINANCED: false,
  MULTI_PROVINCE: true,
  URGENT: false
}

export const SHOW_HIGHLIGHTED_ADS = false

export const SORT_BY_PRICE = {
  [COMMON_SORT_FIELDS.PRICE]: {
    queryParam: 'Price',
    label: {
      [ORDER.ASC]: 'SORT_PRICE_CASH_ASC',
      [ORDER.DESC]: 'SORT_PRICE_CASH_DESC'
    }
  }
}

export const SORT_BY_INSTALMENT_PRICE = {
  [COMMON_SORT_FIELDS.INSTALMENT]: {
    queryParam: 'financingInstalment',
    label: {
      [ORDER.ASC]: 'SORT_PRICE_INSTALMENT_ASC',
      [ORDER.DESC]: 'SORT_PRICE_INSTALMENT_DESC'
    }
  }
}

export const SORT_BY_KM = {
  [COMMON_SORT_FIELDS.KM]: {
    queryParam: 'Kilometers',
    label: {
      [ORDER.ASC]: 'SORT_KMS_COCHES_ASC',
      [ORDER.DESC]: 'SORT_KMS_COCHES_DESC'
    }
  }
}

export const SORT_BY_MONTHLY_SUBSCRIPTION_FEE = {
  [COMMON_SORT_FIELDS.MONTHLY_SUBSCRIPTION_FEE]: {
    queryParam: 'monthlySubscriptionFee',
    label: {
      [ORDER.ASC]: 'SORT_MONTHLY_SUBSCRIPTION_FEE_COCHES_ASC',
      [ORDER.DESC]: 'SORT_MONTHLY_SUBSCRIPTION_FEE_COCHES_DESC'
    }
  }
}

export const SORT_BY_YEAR = {
  [COMMON_SORT_FIELDS.YEAR]: {
    queryParam: 'Year',
    label: {
      [ORDER.ASC]: 'SORT_YEAR_COCHES_ASC',
      [ORDER.DESC]: 'SORT_YEAR_COCHES_DESC'
    }
  }
}

// in fact, this is sorting by date
export const SORT_BY_RELEVANCE = {
  [COMMON_SORT_FIELDS.RELEVANCE]: {
    queryParam: 'SortDate',
    label: {
      [ORDER.DESC]: 'SORT_DATE_RELEVANCE_DESC'
    }
  }
}

/**
 * @exports SORT
 */
export const SORT = {
  ...SORT_BY_RELEVANCE,
  ...SORT_BY_PRICE,
  ...SORT_BY_INSTALMENT_PRICE,
  ...SORT_BY_KM,
  ...SORT_BY_MONTHLY_SUBSCRIPTION_FEE,
  ...SORT_BY_YEAR
}

export const SORT_BY_CATEGORY1_ID = {
  [SEGUNDA_MANO_CATEGORY1_ID]: {
    ...SORT_BY_RELEVANCE,
    ...SORT_BY_PRICE,
    ...SORT_BY_INSTALMENT_PRICE,
    ...SORT_BY_KM,
    ...SORT_BY_YEAR
  },
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: {
    ...SORT_BY_RELEVANCE,
    ...SORT_BY_PRICE,
    ...SORT_BY_INSTALMENT_PRICE,
    ...SORT_BY_KM,
    ...SORT_BY_YEAR
  },
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: {
    ...SORT_BY_RELEVANCE,
    ...SORT_BY_PRICE
  },
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: {...SORT_BY_RELEVANCE, ...SORT_BY_PRICE},
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: {
    ...SORT_BY_RELEVANCE,
    ...SORT_BY_PRICE,
    ...SORT_BY_YEAR
  }
}

/**
 * @exports ADS_LIST_SUBSCRIPTION_SORT
 */
export const ADS_LIST_SUBSCRIPTION_SORT = {
  ...SORT_BY_RELEVANCE,
  ...SORT_BY_MONTHLY_SUBSCRIPTION_FEE,
  ...SORT_BY_YEAR
}

/**
 * @exports MODELS_LIST_SORT
 */
export const MODELS_LIST_SORT = {
  ...SORT_BY_PRICE
}

/**
 * @exports TECHNICAL_DETAILS_SORT
 */
export const TECHNICAL_DETAILS_SORT = {
  [COMMON_SORT_FIELDS.TITLE]: {
    queryParam: 'Title',
    label: {
      [ORDER.ASC]: 'SORT_TITLE_ASC'
    }
  },
  [COMMON_SORT_FIELDS.YEAR]: {
    queryParam: 'Year',
    label: {
      [ORDER.ASC]: 'SORT_YEAR_COCHES_ASC',
      [ORDER.DESC]: 'SORT_YEAR_COCHES_DESC'
    }
  },
  [COMMON_SORT_FIELDS.HP]: {
    queryParam: 'HP',
    label: {
      [ORDER.ASC]: 'SORT_HP_ASC',
      [ORDER.DESC]: 'SORT_HP_DESC'
    }
  }
}

/**
 * @exports DEALERS_LIST_SORT
 */
export const DEALERS_LIST_SORT = {
  [COMMON_SORT_FIELDS.TITLE]: {
    queryParam: 'Title',
    label: {
      [ORDER.ASC]: 'SORT_TITLE_ASC'
    }
  }
}

/**
 * @exports CREATE_ALERT_QUERY_PARAM
 */
export const CREATE_ALERT_QUERY_PARAM = 'createAlert'

export const PHONE_CALL_QUERY_PARAM = 'phoneCall'

/**
 * @exports DEFAULT_FILTERS
 */
export const DEFAULT_FILTERS = {
  [COMMON_FILTER_NAMES.CATEGORY_2]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.MAKE]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.MODEL]: DEFAULT_MODEL,
  [COMMON_FILTER_NAMES.FUEL_TYPE]: DEFAULT_FUEL_TYPES,
  [COMMON_FILTER_NAMES.LITRES]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.BODY_TYPE]: DEFAULT_BODY_TYPES,
  [COMMON_FILTER_NAMES.PROVINCE]: DEFAULT_PROVINCES,
  [COMMON_FILTER_NAMES.ONLY_PENINSULA]: DEFAULT_BOOL_FILTER_VALUE,
  [COMMON_FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.PRICE]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.HAS_INSTALMENT]: DEFAULT_BOOL_FILTER_VALUE,
  [COMMON_FILTER_NAMES.INSTALMENT]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.FINANCING_ENTRY]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.FINANCING_TERMS]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.YEAR]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.KMS]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.SEARCH_TEXT]: DEFAULT_SEARCH_TEXT,
  [COMMON_FILTER_NAMES.SELLER_TYPE]: DEFAULT_SELLER_TYPE,
  [COMMON_FILTER_NAMES.VERSION]: DEFAULT_VERSION,
  [COMMON_FILTER_NAMES.DOOR]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.SEAT]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.HP]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.LUGGAGE_CAPACITY]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.EQUIPMENTS]: DEFAULT_EQUIPMENTS,
  [COMMON_FILTER_NAMES.IS_CERTIFIED]: DEFAULT_BOOL_FILTER_VALUE,
  [COMMON_FILTER_NAMES.HAS_WARRANTY]: DEFAULT_BOOL_FILTER_VALUE,
  [COMMON_FILTER_NAMES.OFFER_TYPE]: UNSELECTED_OFFER_TYPE,
  [COMMON_FILTER_NAMES.TRANSMISSION_TYPE]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.HAS_PHOTO]: DEFAULT_BOOL_FILTER_VALUE,
  [COMMON_FILTER_NAMES.ENVIRONMENTAL_LABEL]: DEFAULT_ENVIRONMENTAL_LABELS,
  [COMMON_FILTER_NAMES.DRIVEN_WHEELS]: DEFAULT_DRIVEN_WHEELS,
  [COMMON_FILTER_NAMES.VEHICLE_STATE]: DEFAULT_VEHICLE_STATE,
  [COMMON_FILTER_NAMES.EXCLUDED_VEHICLES]: DEFAULT_EXCLUDED_VEHICLES,
  [COMMON_FILTER_NAMES.VEHICLES]: DEFAULT_VEHICLES,
  [COMMON_FILTER_NAMES.LOCATION]: DEFAULT_LOCATION
}

export const DEFAULT_SEARCH = {
  ...DEFAULT_FILTERS,
  categoryId: DEFAULT_CATEGORY1_ID,
  offerTypeId: DEFAULT_OFFER_TYPE_ID,
  page: DEFAULT_PAGE_NUMBER,
  [COMMON_FILTER_NAMES.SORT_BY]: COMMON_SORT_FIELDS.RELEVANCE,
  sortOrder: ORDER.DESC
}

export const DEFAULT_RENTING_SEARCH = {
  ...DEFAULT_SEARCH,
  offerTypeId: OFFER_TYPE_SUBSCRIPTION
}

export const UNIQUE_LISTING_DEFAULT_SEARCH = {
  ...DEFAULT_SEARCH,
  offerTypeId: UNSELECTED_OFFER_TYPE
}

export const RENTING_DEFAULT_SEARCH = {
  page: 1,
  sortBy: 'relevance',
  sortOrder: 'DESC',
  bodyTypeIds: [],
  fee: {},
  fuelTypeIds: [],
  hasStock: false,
  monthlySubscriptionFee: {},
  offerTypeId: 10,
  transmissionTypeId: 0,
  vehicles: []
}

export const SHOW_MULTI_PROVINCE_INFO_ADS = true

export const STATISTICS_TYPES = {
  averagePrice: 'AVERAGE_PRICE',
  averageKm: 'AVERAGE_KM',
  averageConsumption: 'AVERAGE_CONSUMPTION',
  popularYear: 'POPULAR_YEAR',
  popularFuelType: 'POPULAR_FUEL_TYPE',
  popularColor: 'POPULAR_COLOR'
}

export const AVAILABLE_FINANCING_LENDERS = {
  bbva: 'bbva',
  cofidis: 'cofidis',
  santander: 'santander',
  caixa: 'caixa'
}

export const IS_STATS_DATA_ENABLED = true

export const DEFAULT_FILTERS_PLACEHOLDERS = {
  [FILTER_NAMES.BODY_TYPE]: 'COMMON.BODY_TYPE',
  [FILTER_NAMES.CATEGORY_2]: 'COMMON.VEHICLE_TYPE',
  [FILTER_NAMES.FUEL_TYPE]: 'COMMON.FUEL',
  [FILTER_NAMES.KMS]: 'COMMON.KMS',
  [FILTER_NAMES.LOCATION]: 'COMMON.LOCATION',
  [FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID]: 'COMMON.LOCATION',
  [FILTER_NAMES.MAKE]: 'COMMON.MAKE',
  [FILTER_NAMES.MODEL]: 'COMMON.PLURALS.MODEL',
  [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: 'COMMON.COMMITMENT',
  [FILTER_NAMES.PRICE]: 'COMMON.PRICE',
  [FILTER_NAMES.PROVINCE]: 'COMMON.PLURALS.PROVINCE',
  [FILTER_NAMES.SELLER_TYPE]: 'COMMON_SELLER_TYPE',
  [FILTER_NAMES.VEHICLES]: 'COMMON.MAKE_MODEL',
  [FILTER_NAMES.YEAR]: 'COMMON.YEAR'
}

export const DEFAULT_FILTERS_LABELS = {
  [FILTER_NAMES.BODY_TYPE]: 'COMMON.BODY_TYPE',
  [FILTER_NAMES.CATEGORY_2]: 'COMMON.VEHICLE_TYPE',
  [FILTER_NAMES.FUEL_TYPE]: 'COMMON.FUEL_TYPE',
  [FILTER_NAMES.KMS]: 'COMMON.MILEAGE',
  [FILTER_NAMES.MAKE]: 'COMMON.MAKE',
  [FILTER_NAMES.MODEL]: 'COMMON.PLURALS.MODEL',
  [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: 'COMMON.COMMITMENT',
  [FILTER_NAMES.PROVINCE]: 'COMMON.PLURALS.PROVINCE',
  [FILTER_NAMES.SELLER_TYPE]: 'COMMON_SELLER_TYPE',
  [FILTER_NAMES.VEHICLES]: 'COMMON.MAKE_MODEL',
  [FILTER_NAMES.YEAR]: 'COMMON.PRODUCTION_YEAR'
}

export const HAS_RECOMMENDER = true

export const RECOMMENDATIONS_TARGETS = {
  DEALER_NO_RESPONSE: 'dealerNoResponse'
}

export const ENABLED_COMPARATOR_CATEGORY_IDS = [
  DEFAULT_CATEGORY1_ID, // Ocasión, Nuevo, KM0
  VANS_AND_COMMERCIAL_CATEGORY1_ID // Furgonetas
]
